module.exports = __webpack_public_path__ + "img/balloon_brown.1df95f4b.svg";